import styles from "./Slide.module.scss"

const ReferenceSliderSlide = ({ data }) => {
  // console.log("ReferenceSliderSlide", data)

  return (
    <div className={styles.ReferenceSlider__Slide}>
      {data?.teaser && (
        <div
          className={styles.teaser}
          dangerouslySetInnerHTML={{ __html: data?.teaser }}
        />
      )}
      {data?.headline && (
        <div
          className={styles.headline}
          dangerouslySetInnerHTML={{ __html: data?.headline }}
        />
      )}
      {data?.subline && (
        <div
          className={styles.subline}
          dangerouslySetInnerHTML={{ __html: data?.subline }}
        />
      )}
      {data?.text && (
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: data?.text }}
        />
      )}
    </div>
  )
}

export default ReferenceSliderSlide
